import { KSelect, KTextField } from "kinnect-general";
import {
	VCard,
	VCardText,
	VCardTitle,
	VCol,
	VRow
} from "vuetify/lib";

export default {
	name: "SealantCalculator",

	data: () => ( {
		depth: null,
		depthUnits: 1,
		linearFeet: null,
		precision: 2,
		units: [
			{
				text: "Inches",
				value: 1
			},
			{
				text: "Feet",
				value: 12
			}
		],
		width: null,
		widthUnits: 1
	} ),

	computed: {
		exactGallons() {
			if ( this.scaledDepth && this.scaledWidth && this.linearFeet ) {
				return ( ( this.scaledDepth * this.scaledWidth * ( this.linearFeet * 12 ) ) * 0.00433 );
			}
		},

		gallons() {
			if ( this.exactGallons ) {
				return parseFloat( this.exactGallons.toFixed( this.precision ) );
			}
		},

		tenPointOneOzCartridges() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons * 128 / 10.3 ).toFixed( this.precision ) );
			}
		},

		twoGallonPails() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons / 2 ).toFixed( this.precision ) );
			}
		},

		fiveGallonPails() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons / 5 ).toFixed( this.precision ) );
			}
		},

		sausagePacks() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons * 128 / 20 ).toFixed( this.precision ) );
			}
		},

		onePointFiveGallons() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons / 1.5 ).toFixed( this.precision ) );
			}
		},

		oneQtCartridges() {
			if ( this.exactGallons ) {
				return parseFloat( ( this.exactGallons * 4 ).toFixed( this.precision ) );
			}
		},

		scaledDepth() {
			return this.depth * this.depthUnits;
		},

		scaledWidth() {
			return this.width * this.widthUnits;
		}
	},

	watch: {
		exactGallons( gallons ) {
			if ( gallons ) {
				this.$ga.event( {
					eventCategory: "Sealant Calculator",
					eventAction: "Calculated",
					eventLabel: `${this.scaledWidth}ft W x ${this.scaledDepth}ft D x ${this.linearFeet}LF`
				} );
			}
		}
	},

	render() {
		return <VRow>
			<VCol cols={12}>
				<h1 class="text-h4">Sealant Coverage Calculator</h1>
				<h2 class="text-subtitle-1">Single Joint, Rectangular</h2>
			</VCol>

			<VCol cols={12} sm={6}>
				<VCard>
					<VCardTitle>Input</VCardTitle>

					<VCardText>
						<VRow>
							<VCol cols={12} sm={6}>
								<KTextField
									hideDetails
									label="Width"
									type="number"
									vModel={this.width}
								></KTextField>
							</VCol>

							<VCol cols={12} sm={6}>
								<KSelect
									hideDetails
									items={this.units}
									label="Width Units"
									vModel={this.widthUnits}
								></KSelect>
							</VCol>
						</VRow>

						<VRow>
							<VCol cols={12} sm={6}>
								<KTextField
									hideDetails
									label="Depth"
									type="number"
									vModel={this.depth}
								></KTextField>
							</VCol>

							<VCol cols={12} sm={6}>
								<KSelect
									hideDetails
									items={this.units}
									label="Depth Units"
									vModel={this.depthUnits}
								></KSelect>
							</VCol>
						</VRow>

						<VRow>
							<VCol cols={12} sm={6}>
								<KTextField
									hideDetails
									label="Linear Feet"
									type="number"
									vModel={this.linearFeet}
								></KTextField>
							</VCol>
						</VRow>
					</VCardText>
				</VCard>
			</VCol>

			<VCol cols={12} sm={6}>
				<VCard>
					<VCardTitle>Results</VCardTitle>

					<VCardText>
						<KTextField
							label="Gallons"
							readonly
							value={this.gallons}
						></KTextField>

						<KTextField
							label="10.1 oz. Cartridges"
							readonly
							value={this.tenPointOneOzCartridges}
						></KTextField>

						<KTextField
							label="2 Gallon Pails"
							readonly
							value={this.twoGallonPails}
						></KTextField>

						<KTextField
							label="5 Gallon Pails"
							readonly
							value={this.fiveGallonPails}
						></KTextField>

						<KTextField
							label="Sausage Packs"
							readonly
							value={this.sausagePacks}
						></KTextField>

						<KTextField
							label="1.5 Gallon Units"
							readonly
							value={this.onePointFiveGallons}
						></KTextField>

						<KTextField
							label="1 Qt. Cartridges"
							readonly
							value={this.oneQtCartridges}
						></KTextField>
					</VCardText>
				</VCard>
			</VCol>
		</VRow>;
	}
};
